import { Award, LayoutTemplate } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const CertificatePage = lazyPage(() => import("./CertificatesPage"), "CertificatePage");
const CertificatesPage = lazyPage(() => import("./CertificatesPage"), "CertificatesPage");
const LookupPage = lazyPage(() => import("./PublicPages"), "LookupPage");
const MyCertificatesPage = lazyPage(() => import("./PublicPages"), "MyCertificatesPage");
const TemplateEditorPage = lazyPage(() => import("./TemplatesPage"), "TemplateEditorPage");
const TemplatesPage = lazyPage(() => import("./TemplatesPage"), "TemplatesPage");

export default defineModuleUi({
  key: "certificates",
  title: "Certificados",
  domain: "documents",
  icon: Award,
  menu: [
    { path: "/documentos/certificados", label: "Certificados", minRole: "member", icon: Award, order: 20, keywords: "certificado emissão lote revogação código verificação conclusão turma palestra" },
    { path: "/documentos/modelos-certificado", label: "Modelos de certificado", minRole: "member", icon: LayoutTemplate, order: 22, keywords: "layout modelo certificado assinatura versão prévia" },
  ],
  routes: [
    { path: "/documentos/certificados", element: <CertificatesPage />, minRole: "member" },
    { path: "/documentos/certificados/:id", element: <CertificatePage />, minRole: "member" },
    { path: "/documentos/modelos-certificado", element: <TemplatesPage />, minRole: "member" },
    { path: "/documentos/modelos-certificado/:id", element: <TemplateEditorPage />, minRole: "member" },
  ],
  publicRoutes: [
    { path: "/meus-certificados", element: <LookupPage /> },
    { path: "/meus-certificados/:org", element: <LookupPage /> },
  ],
  portal: {
    menu: [{ path: "/portal/certificados", label: "Certificados", minRole: "client", icon: Award, order: 210 }],
    routes: [{ path: "/portal/certificados", element: <MyCertificatesPage />, minRole: "client" }],
  },
});
